import React, { Component } from "react";
import Tooltip from "../../components/UI/TooltipIcon/TooptipIcon";
import orderBy from "lodash/orderBy";
import { toastContainer } from "../../utils/toast.js";
import moment from "moment";
import { Link } from "react-router-dom";
import "./reporting.css";
import BottomScrollListener from "react-bottom-scroll-listener";
import placeholder from "./../../assets/toolkit-favorite-placeholder.svg";
import { isMobile } from "../../utils/deviceInfo";
import FooterBar from "../../components/FooterBar/FooterBar";
import rocket from "../../assets/onboarding/rocket.png";
import trending from "../../assets/trending.svg";
import toolkit from "../../assets/onboarding/toolkit.png";
import ww from "../../assets/onboarding/ww.png";
import welcome from "../../assets/onboarding/welcome.png";
import analytics from "../../assets/onboarding/analytics.png";
import officeCreatedIcon from "../../assets/office_created_icon.svg";
import {
  Modal,
  ModalBody,
  Button,
  Progress,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
  InputGroup,
  Input,
  InputGroupAddon,
  Collapse,
} from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import EmptyTable from "../../components/EmptyTable/EmptyTable";
import "rc-checkbox/assets/index.css";
import drillDownClose from "../../assets/drilldown_close.svg";
import stories from "../../assets/onboarding/Stories.png";
import welcomeStory from "../../assets/onboarding/wStory.svg";
import { storyTemplates, staticTitles, profilePicValidityCheck } from "../../utils/constants";

import axios from "../../axios";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import { capitalizeFirstLetter } from "../../utils/stringUtils";
import Loading from "../../hoc/Loading/Loading";
import { ListGroup, ListGroupItem } from "reactstrap";
import avatarIcon from "../../assets/default-avatar.png";
import Toggle from "react-toggle";
import ShowMore from "react-show-more";
import PlaceholderStories from "../stories/PlaceholderStories";
import If from "../../components/Shared/If";
import classnames from "classnames";
import get from "lodash/get";
import filter from "lodash/filter";
import size from "lodash/size";
import StoryItems from "../stories/StoryItems.jsx";
import StoryFilter from "../stories/StoryFilter.jsx";

import {
  tools,
  filtersData,
  toolkitCategoryFilterMapping,
  getDisplayByKey,
  getTypeByKey,
  getAppliedFiltersCount,
  toolkitCategoryFilterValues,
  addToolStep,
  getSubcategories,
  UserRole,
} from "./../../utils/constants";

class StoryAndComments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docType: "all",
      stories: [],
      url: "",
      list: [],
      value_cat: this.props.value_cat,
      storyType: {},
      originalStoryTotal: 0,
      skipValue: 0,
      archievedStories: [],
      privacy: "PUBLIC",
      organizationId: this.props.user.profile.organizationId._id,
      isAnonymous: false,
      isAnonymousVisible: true,
      selectedFilter: [],
      filters: [],
      topicsSelected: [{ name: "All" }],
      isRemoved: false,
      removedIntro: "Don't show this again",
      disableSubmit: true,
      showReplies: false,
      mentionsSelected: [],
      sentiment: null,
      suggest: [],
      isBadWords: false,
      sentimentColor: "",
      sentimentValue: "",
      mentionsFound: [],
      topicAlert: false,
      showArchived: false,
      isSentiment: true,
      isUrl: false,
      mentionWord: "",

      isEditStory: false,
      totalStories: 0,
      storyTopic: "all",
      description: {
        value: "",
        error: false,
      },
      topics: [],
      showIntro: !this.props.user.profile.hideIntro,
      // showIntro:this.props.user.profile.role==="Member" && this.props.user.profile.hideIntro!=true?true: false,
      mentionBool: false,
      mentionsIndex: 0,
      dropdownOpen: false,
      title: "",
      showCreateStoryModal: false,
      modalActionType: "Create",
      categoryDefinitionPopoverOpen: false,
      collapseCompleted: true,
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
      FilterSkipValue: 0,
      Filtermode: 0,
      ClearFiltermode: 0,
      Categoriesfilters: [],
      Tagsfilters: [],
      selectedCategoriesFiltercount: 0,
      selectedTagFilterccount: 0,
      searchedTerm: "",
      isFilterCollapsed: false,
      timerId: "",
      limit: 0,
      isApiLoading: false,
    };
  }

  componentDidMount() {
    const { kpiMasterList } = this.props.kpiMaster;
    const { mappingMasterList } = this.props.mappingMaster;
    const { organizationId } = this.props.user.profile;

    console.log("value --- ", this.props.value_cat);
    let limit;
    if (isMobile) {
      this.props.updateNavBar({
        title: "Enterprise",
        hasBack: true,
        backButton: "<b>Back</b>",
        showNotification: true,
        className: null,
        isBreadCrumbs: false,
      });
      this.setState({ limit: 3 });
    } else {
      this.setState({ limit: 6 });
    }

    this.getStoryFeeds();
    this.getTopics();
    let that = this;

    axios.get(url.findOrgById(organizationId._id)).then(({ data }) => {
      const payload = data.data;
      that.props.orgChangeSuccess(payload);
    });

    // this.props.history.location.pathname='/home/stories'
    this.setState({ url: this.props.match.url });

    // console.log(this.props)
    if (kpiMasterList.length === 0) {
      axios.get(url.getKpiMaster).then(({ data }) => {
        const payload = data.data;
        this.props.onKpiMasterListFetched(payload);
      });
    }
    if (
      this.props.mappingMaster.length === 0 ||
      !mappingMasterList ||
      mappingMasterList.length === 0
    ) {
      axios
        .get(url.getExistingMappings(organizationId._id))
        .then(({ data }) => {
          const payload = data.data;
          this.props.onMappingMasterListFetched(payload.mapping);
        });
    }
  }

  getTopics = () => {
    let orgId = this.props.user.profile.organizationId._id;

    axios.get(url.getTopics(orgId)).then(({ data }) => {
      // console.log("data---", data.data)
      let topics = data.data;
      this.setState({
        topics: [...topics],
      });
    });
  };

  getStoryFeeds = async (res) => {
    // console.log(window.location.pathname)
    //this function will be called if all filters is cleared
    // Filtermode is set as 0 to differentiate that no filters are selected and stories need to be appended when scrolling.
    // When set as 1 the stories based on filter result will be replaced
    this.setState({ Filtermode: 0 });
    // return
    let { skipValue, limit, isApiLoading } = this.state;

    if (res && res.isSearchCleared == true) {
      skipValue = 0;
      this.setState({ skipValue: 0 });
    }

    let orgId = this.props.user.profile.organizationId._id;
    const organizationId = orgId ? orgId : res.profile.organizationId._id;

    let limitValue = limit == 0 ? (isMobile ? 3 : 6) : limit;

    let value = res && res.value_cat ? res.value_cat : this.props.value_cat;

    const config = {
      headers: { Pragma: "no-cache" },
    };
    // axios.get(url.getStories(organizationId, value))
    if (isApiLoading == false) {
      // console.log('afer APILOadng')
      this.setState({ isApiLoading: true });
      axios
        .get(url.showFlaggedContent, {
          params: {
            organizationId,
            value,
            skipValue,
            limitValue,
          },
        })
        .then(async ({ data }) => {
          if (data && data.data) {
            // ClearFiltermode is for onload changes when a clear filter button is pressed or when All category is clicked or when all the filters are cleared CleaClearFiltermode is checked as 0 to replace the previous fetch results that was based on the filter and show maximum 10 stories as existing
            // When ClearFiltermode set as 1 the stories will be appended to the fetch results.
            // console.log('this.state.ClearFiltermod ---', this.state.ClearFiltermod)

            if (this.state.ClearFiltermode == 0) {
              //Skip value increament by 10

              this.setState((prevState) => ({
                stories:
                  res && res.isSearchCleared == true
                    ? //Later remove this map once api is fixed currently doing it coz api return weird format response
                      [...data.data.storyList]
                    : [...prevState.stories, ...data.data.storyList],
                topicAlert: false,
                skipValue: prevState.skipValue + limitValue,
                profile: this.props.user.profile,
                totalStories: data.data.storyTotal,
                originalStoryTotal: data.data.storyTotal,
                ClearFiltermode: 1,
                value_cat: this.props.value_cat,
                isApiLoading: false,
              }));
            } else {
              //While scroll down stories result append to stories state
              //Skip value increament by 10
              this.setState((prevState) => ({
                stories:
                  res && res.isSearchCleared == true
                    ? [...data.data.storyList]
                    : [...prevState.stories, ...data.data.storyList],
                topicAlert: false,
                skipValue: prevState.skipValue + limitValue,
                profile: this.props.user.profile,
                totalStories: data.data.storyTotal,
                originalStoryTotal: data.data.storyTotal,
              }));
            }
            await this.setState({ isApiLoading: false });
          }
        });
    }
  };
  toggleDefinitionPopover = () =>
    this.setState({
      categoryDefinitionPopoverOpen: !this.state.categoryDefinitionPopoverOpen,
    });

  showStoryComments = (item) => {
    // console.log(item)
    axios.get(url.getStoryComments(item)).then(({ data }) => {
      // this.getStoryFeeds();
      // console.log(data)
      let arr = data.data.storyList;
      this.setState({
        showResponses: [...arr],
      });
    });
  };

  showStoryRemoveConfirmation = (storyId) => {
    // console.log(storyId)
    this.setState({
      showRemoveFeedConfirmationModal: !this.state
        .showRemoveFeedConfirmationModal,
      storyIdRemove: storyId,
    });
  };

  closeStoryRemoveConfirmation = (storyId) => {
    this.setState({
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
    });
  };

  createMarkup = (input) => {
    // console.log(input)
    return { __html: `<div>${input}</div>` };
  };

  createResponse = () => {
    this.setState((prevState) => ({ showReplies: !prevState.showReplies }));
  };

  toggleCollapse = () => {
    const { isFilterCollapsed } = this.state;
    this.setState({
      isFilterCollapsed: !isFilterCollapsed,
    });
  };

  filterTopic = async (topic) => {
    this.setState({ FilterSkipValue: 0, Filtermode: 1 });
    let name = topic.code ? topic.code : topic;
    let {
      filters,
      selectedFilter,
      filteredStories,
      originalStoryTotal,
      selectedCategoriesFiltercount,
    } = this.state;
    const list = orderBy(this.state.stories, "createdOn", "desc");
    let list2 = list.map((a) => ({ ...a }));
    let sfilter = selectedFilter.map((a) => a);

    if (name !== "all") {
      if (filters.indexOf(name) > -1) {
        sfilter = sfilter.filter((e) => e !== name);

        this.setState((prevState) => ({
          filters: filters.filter((e) => e !== name),
          selectedFilter: selectedFilter.filter((e) => e !== name),
          selectedCategoriesFiltercount:
            prevState.selectedCategoriesFiltercount - 1,
        }));
      } else {
        sfilter = [sfilter, name];

        await this.setState((prevState) => ({
          filters: [...prevState.filters, name],
          selectedFilter: [...prevState.selectedFilter, name],
          selectedCategoriesFiltercount:
            prevState.selectedCategoriesFiltercount + 1,
        }));
      }

      let fList = list2.filter((item) => {
        let itemTopic =
          item.topics && item.topics.length > 0
            ? item.topics.map((e) => e.code)
            : [];
        let template = item.template ? item.template._id : "";
        itemTopic.push(template);
        let dup = itemTopic.concat(sfilter);
        let set1 = new Set(dup);
        if (sfilter.length > 0) {
          if (dup.length > set1.size) {
            return item;
          }
        } else {
          return item;
        }
      });

      if (fList) {
        await this.setState({ totalStories: fList.length });
      }
      clearTimeout(this.state.timerId);
      let callfunction = this;
      this.state.timerId = setTimeout(function() {
        callfunction.getStoryFilterFeeds();
      }, 1000);
    } else {
      let { stories } = this.state;
      await this.setState((prevState) => ({
        filters: [],
        selectedFilter: [],
        totalStories: originalStoryTotal,
        selectedCategoriesFiltercount: 0,
      }));
      if (
        this.state.searchedTerm.length != 0 ||
        this.state.filters.length != 0 ||
        this.state.Tagsfilters.length != 0
      ) {
        this.getStoryFilterFeeds();
      } else {
        await this.setState({ stories: [], FilterSkipValue: 0 });
        this.handleClearFilters();
      }
    }
  };

  filterbyTag = async (tag) => {
    await this.setState({ FilterSkipValue: 0, Filtermode: 1 });
    if (tag !== "all") {
      let tag_id = tag._id ? tag._id : tag;
      let { Tagsfilters } = this.state;
      let { filters } = this.state;
      let { searchedTerm, FilterSkipValue } = this.state;

      if (Tagsfilters.indexOf(tag_id) > -1) {
        await this.setState((prevState) => ({
          Tagsfilters: Tagsfilters.filter((e) => e !== tag_id),
          selectedTagFilterccount: prevState.selectedTagFilterccount - 1,
        }));
      } else {
        if (this.state.Tagsfilters.length > 0) {
          await this.setState((prevState) => ({
            Tagsfilters: [...prevState.Tagsfilters, tag_id],
            selectedTagFilterccount: prevState.selectedTagFilterccount + 1,
          }));
        } else {
          await this.setState((prevState) => ({
            Tagsfilters: [tag_id],
            selectedTagFilterccount: prevState.selectedTagFilterccount + 1,
          }));
        }
      }

      let { skipValue } = this.state;
      let organizationId = this.props.user.profile.organizationId._id;
      let tag_filter = this.state.Tagsfilters;
      let category_filters = this.state.filters;
      let searchedTerm_text = this.state.searchedTerm;
      let value = "all";
      clearTimeout(this.state.timerId);
      let callfunction = this;
      this.state.timerId = setTimeout(function() {
        callfunction.getStoryFilterFeeds();
      }, 1000);
    } else {
      await this.setState((prevState) => ({
        Tagsfilters: [],
        selectedTagFilterccount: 0,
        FilterSkipValue: 0,
      }));
      if (
        this.state.searchedTerm.length != 0 ||
        this.state.filters.length != 0 ||
        this.state.Tagsfilters.length != 0
      ) {
        this.getStoryFilterFeeds();
      } else {
        await this.setState({ stories: [], FilterSkipValue: 0 });
        this.handleClearFilters();
      }
    }
  };

  async getStoryFilterFeeds() {
    let organizationId = this.props.user.profile.organizationId._id;
    let tag_filter = this.state.Tagsfilters;
    let category_filters = this.state.filters;
    const {
      FilterSkipValue,
      filters,
      searchedTerm,
      limit,
      isApiLoading,
      docType,
    } = this.state;
    let params = {
      organizationId: organizationId,
      tag_filter: tag_filter,
      category_filters: category_filters,
      searchedTerm: searchedTerm,
      skipValue: FilterSkipValue,
      limitValue: limit,
      value: "all",
      isFlagged: true,
      type:
        docType === "all"
          ? ""
          : docType === "story"
          ? "story"
          : "storyResponse",
    };
    console.log("call");
    if (isApiLoading == false) {
      await this.setState({ isApiLoading: true });
      axios
        .get(url.getStoriesbyfilter, {
          params: params,
        })
        .then(async ({ data }) => {
          // console.log('data---', data.data)
          await this.setState({ isApiLoading: false });
          if (data && data.data) {
            console.log(data);
            if (this.state.FilterSkipValue == 0) {
              this.setState({ stories: [] });
            }
            console.log([...data.data.storyList]);

            if (this.state.Filtermode == 1) {
              this.setState((prevState) => ({
                stories: [...data.data.storyList],
                topicAlert: false,
                FilterSkipValue: prevState.FilterSkipValue + limit,
                profile: this.props.user.profile,
                totalStories: data.data.storyTotal,
                originalStoryTotal: data.data.storyTotal,
                Filtermode: 0,
                ClearFiltermode: 0,
              }));
            } else {
              this.setState((prevState) => ({
                // ...prevState.stories,
                stories: [...data.data.storyList],
                topicAlert: false,
                FilterSkipValue: prevState.FilterSkipValue + limit,
                profile: this.props.user.profile,
                totalStories: data.data.storyTotal,
                originalStoryTotal: data.data.storyTotal,
                ClearFiltermode: 0,
              }));
            }
          }
        });
    }
  }
  //This function use for clear filter related state and call getStoryFeeds and getTopics
  //to get result from getStoryFeeds (common onload function for getting stories) && getTopics function (its return topic result based on user id)

  async handleClearFilters(val) {
    let { stories, originalStoryTotal, searchedTerm } = this.state;
    this.setState(
      (prevState) => ({
        skipValue: 0,
        FilterSkipValue: 0,
        filters: [],
        selectedFilter: [],
        Tagsfilters: [],
        selectedCategoriesFiltercount: 0,
        selectedTagFilterccount: 0,
        totalStories: originalStoryTotal,
        searchedTerm: "",
        Filtermode: 0,
        ClearFiltermode: 0,
      }),
      () => {
        this.getStoryFeeds(val);
      }
    );

    if (val && !isMobile) {
      this.getTopics();
    }
  }

  handleSearchQueryChanged = async (event) => {
    this.setState({
      searchedTerm: event.target.value,
      FilterSkipValue: 0,
      SkipValue: 0,
      ClearFiltermode: 0,
      Filtermode: 1,
    });
    let targetValue = event.target.value;
    let tag_filter = this.state.Tagsfilters;
    let category_filters = this.state.filters;
    if (targetValue != "") {
      clearTimeout(this.state.timerId);
      let callfunction = this;
      this.state.timerId = setTimeout(function() {
        callfunction.getStoryFilterFeeds();
      }, 1000);

      // return a function which will cancel the timer
    } else if (
      targetValue.length == 0 &&
      tag_filter.length == 0 &&
      category_filters.length == 0
    ) {
      this.setState({ FilterSkipValue: 0, skipValue: 0 });
      this.handleClearFilters({ isSearchCleared: true });
    } else {
      this.getStoryFilterFeeds();
    }
  };

  handleOnDocumentBottom = async () => {
    let {
      totalStories,
      skipValue,
      filters,
      Tagsfilters,
      searchedTerm,
      FilterSkipValue,
      limit,
    } = this.state;
    if (
      filters.length > 0 ||
      Tagsfilters.length > 0 ||
      searchedTerm.length > 0
    ) {
      if (FilterSkipValue < totalStories && totalStories > limit) {
        console.log("1");
        this.getStoryFilterFeeds();
      }
    } else {
      if (skipValue < totalStories && totalStories > limit) {
        console.log("2");
        this.getStoryFeeds();
      }
    }
    if (this.props.alertOnBottom) {
      alert(
        'Bottom of this container hit! Too slow? Reduce "debounce" value in props'
      );
    }
  };

  editParticularStoryobj = (story) => {
    console.log("CALL");
    const { stories } = this.state;
    const storyIndex = stories.findIndex((x) => x._id === story._id);
    let storiesArray = [...stories];
    console.log("-----", storyIndex);
    if (storyIndex >= 0) {
      if (
        (story.isFlagged && story.isFlagged.status === true) ||
        story.unflagged
      ) {
        storiesArray.splice(storyIndex, 1);
        this.setState({ stories: [...storiesArray] });
      } else {
        storiesArray[storyIndex] = { ...storiesArray[storyIndex], ...story };
        this.setState({ stories: [...storiesArray] });
      }
    }
  };

  removeStoryFeeds = (id, type) => {
    let { stories } = this.state;
    this.setState({ showRemoveFeedConfirmationModal: false });
    const filteredStories = stories.filter((e) => e._id !== id);

    axios.put(url.removeStoryFeeds(id)).then((resp) => {
      if (resp.data.data.parentStory && resp.data.data.parentStory.item) {
        this.showStoryComments(resp.data.data.parentStory.item);
      }
      this.setState((prevState) => ({
        dropdownOpen: false,
        stories: [...filteredStories],
        totalStories: prevState.totalStories - 1,
        originalStoryTotal: prevState.originalStoryTotal - 1,
      }));
    });
  };

  renderStories = () => {
    let list = orderBy(this.state.stories, "createdOn", "desc");

    const { description, selectedFilter } = this.state;
    let filters = this.state.topics;
    console.log("list --- ", list.length);
    let fList = list.filter((item) => {
      let itemTopic =
        item.topics && item.topics.length > 0
          ? item.topics.map((e) => e.code)
          : [];
      let template = item.template ? item.template._id : "";
      itemTopic.push(template);
      let dup = itemTopic.concat(selectedFilter);
      let set1 = new Set(dup);
      if (selectedFilter.length > 0) {
        if (dup.length > set1.size) {
          return item;
        }
      } else {
        return item;
      }
    });

    if (fList && fList.length > 0) {
      if (fList && fList.length && filters && filters.length > 0) {
        return fList.map((item, idx) => {
          const actionType =
            item.isDeleted || item.isArchived ? "Restore" : "Archive";
          let avatar = item.isAnonymous
            ? avatarIcon
            : profilePicValidityCheck(item.profilePic) ? item.profilePic :null || avatarIcon;

          if (selectedFilter.length > 0) {
            return (
              <StoryItems
                editParticularStoryobj={this.editParticularStoryobj}
                showCreateStory={() => {}}
                removeStoryFeeds={this.removeStoryFeeds}
                deArchiveStory={() => {}}
                archiveStory={() => {}}
                filters={filters}
                getStoryFeeds={this.getStoryFeeds}
                showStoryRemoveConfirmation={() => {}}
                key={item._id + idx}
                item={item}
                actionType={actionType}
                avatar={avatar}
                description={description}
                renderFlagged
              />
            );
          } else {
            return (
              <StoryItems
                renderFlagged
                showCreateStory={() => {}}
                removeStoryFeeds={this.removeStoryFeeds}
                deArchiveStory={this.deArchiveStory}
                archiveStory={this.archiveStory}
                filters={filters}
                getStoryFeeds={this.getStoryFeeds}
                showStoryRemoveConfirmation={this.showStoryRemoveConfirmation}
                key={item._id + idx}
                item={item}
                actionType={actionType}
                avatar={avatar}
                description={description}
                editParticularStoryobj={this.editParticularStoryobj}
              />
            );
          }
        });
      } else {
        return (
          <EmptyTable
            title="No results found"
            subtitle="Try changing your filters"
          />
        );
      }
    } else {
      return (
        <div className="noStories">
          <div className="mt20 trendingEmpty">
            <img src={placeholder} />

            <span className="noStoriesContent">
            No stories or comments have been reported
            </span>
          </div>
        </div>
      );
    }
  };

  addUrl = (query, callback) => {
    if (!query) return;
    // console.log('URL ----')
  };

  getStoriesCount = () => {
    const filteredStories = this.state.stories.filter(
      (story) => !story.isDeleted
    );
    this.setState({ totalStories: filteredStories.length });
    // return filteredStories.length
  };

  handleCollapse = () => {
    // console.log("collapse archive ---- 100% height")
    this.setState((prevState) => ({
      collapseCompleted: !prevState.collapseCompleted,
    }));
  };

  changeStoryTopic = (topic) => {
    let { originalStoryTotal } = this.state;
    // let {archievedStories, stories}=this.state
    // if(topic==="archived"){
    //   this.setState( prevState =>({
    //     showArchived: true,
    //     storyTopic: "archived",
    //     totalStories: archievedStories.length
    //   }))
    // }
    if (topic === "all") {
      this.setState((prevState) => ({
        showArchived: false,
        storyTopic: "all",
        totalStories: originalStoryTotal,
      }));
    }
    if (topic === "trending") {
      this.props.history.push(`/home/stories/trending`);
    }
  };

  // we assign state value here for data handle purpose
  render() {
    const {
      storyType,
      description,
      suggest,
      showArchived,
      isSentiment,
      isAnonymous,
      topicsSelected,
      selectedFilter,
      filters,
      topics,
      disableSubmit,
      stories,
      collapseCompleted,
      categoryDefinitionPopoverOpen,
      archievedStories,
      showRemoveFeedConfirmationModal,
      profile,
      isFilterCollapsed,
      searchedTerm,
      Categoriesfilters,
      Tagsfilters,
      selectedCategoriesFiltercount,
      selectedTagFilterccount,
    } = this.state;

    const createStoryModalStyle = classnames(
      "profile-modal-save-btn float-left weeklyWinBtn",
      {
        disabled: disableSubmit,
        disabledBtn: disableSubmit,
      }
    );
    let fullName;

    if (this.state.profile) {
      fullName = `${profile.firstName} ${profile.lastName}`;
    }
    // console.log(this.state.description)
    return (
      <div className="stories flagged-stories">
        <div className={`text-size ${isMobile && "hide"}`}>
          <div className="chartCategoryTop text-size mb-5 pl-2 bgWhite">
            <div className="title-text">Reporting: Stories & Comments</div>
            <div
              className={`ml-1 ${!isMobile && "ml-0"} text-size ${isMobile &&
                "hide"}`}
            >
              <div className="storyCategories">
                <div>
                  {!isMobile || (isMobile && isFilterCollapsed == false) ? (
                    <div
                      className="row p-0 m-0 mobile-search-box"
                      style={{ height: "40px", marginBottom: "1em" }}
                    >
                      <div className="col-lg-9 col-md-12 col-sm-9 col-10 searchStoriesInputContainer">
                        <InputGroup style={{ height: "40px", width: "100%" }}>
                          <Input
                            className="toolkit-field tool-search-box"
                            placeholder="Search in posts"
                            onChange={this.handleSearchQueryChanged}
                            value={searchedTerm}
                          />
                          <InputGroupAddon addonType="append">
                            <i
                              style={{ color: "#818389", padding: "7px" }}
                              className="flaticon-search"
                            ></i>
                          </InputGroupAddon>
                        </InputGroup>
                      </div>

                      {!isMobile ? (
                        <div className="col-lg-3 col-md-12 col-sm-12 mb-2 storiesFilterBtnContainer">
                          <Button
                            color={"secondary-filled"}
                            onClick={this.toggleCollapse}
                            style={{ marginBottom: "1rem", height: "40px" }}
                            className="filter-toggle-button"
                          >
                            <span className="tool-list-font">
                              <i
                                className="flaticon-equalizer"
                                style={{
                                  fontSize: "18px",
                                  marginRight: "8px",
                                  color: "#3B3C41",
                                }}
                              ></i>
                              Filters{" "}
                              {selectedCategoriesFiltercount +
                                selectedTagFilterccount >
                              0 ? (
                                <span style={{ marginLeft: "4px" }}>
                                  (
                                  {selectedCategoriesFiltercount +
                                    selectedTagFilterccount}
                                  )
                                </span>
                              ) : null}
                            </span>
                          </Button>
                        </div>
                      ) : (
                        <div className="col-2 mb-2">
                          <span
                            className="tool-list-font"
                            onClick={this.toggleCollapse}
                          >
                            <i
                              className="flaticon-equalizer"
                              style={{
                                fontSize: "18px",
                                marginRight: "0px",
                                color: "#3B3C41",
                              }}
                            ></i>
                            {selectedCategoriesFiltercount +
                              selectedTagFilterccount >
                            0 ? (
                              <span style={{ marginLeft: "-36px" }}>
                                <span className="mobile-filter-count">
                                  {selectedCategoriesFiltercount +
                                    selectedTagFilterccount}
                                </span>
                              </span>
                            ) : null}
                          </span>
                        </div>
                      )}
                    </div>
                  ) : null}

                  {/*
        1. listed  category list.
        2.if select a category, it will store in state and stories result return by select filter data
        3.selected category changes button color dynamically
        4.selected multiple category option added.
        5.if select all button : clear filter option and return onload stories result
      */}

                  <div className="row p-0 m-0">
                    {isMobile && isFilterCollapsed ? (
                      <StoryFilter
                        toggleCollapseClick={this.toggleCollapse}
                        handleClearFiltersClick={() =>
                          this.handleClearFilters(true)
                        }
                        storyTemplates={storyTemplates}
                        selectedTagFilterccount={selectedTagFilterccount}
                        Tagsfilters={Tagsfilters}
                        topics={topics}
                        selectedCategoriesFiltercount={
                          selectedCategoriesFiltercount
                        }
                        filters={filters}
                        filterbyTagClick={this.filterbyTag}
                        filterTopicClick={this.filterTopic}
                      />
                    ) : null}
                    {!isMobile ? (
                      <Collapse
                        isOpen={isFilterCollapsed}
                        className="col-lg-12 col-sm-12 col-md-12 plpr0 "
                        toggler="#toggler"
                        style={{ width: "100%" }}
                      >
                        <div className="stories-list-filter-container">
                          <div
                            className={`stories-topics ${isMobile && "mt-2"}`}
                          >
                            <Row>
                              <Col sm="12">
                                <div className="templatePara1">
                                  {" "}
                                  Categories{" "}
                                </div>
                              </Col>
                            </Row>
                            {storyTemplates && storyTemplates.length > 0 ? (
                              <div
                                className={`${!isMobile &&
                                  "ml-3"} stories-topics-list`}
                              >
                                {selectedTagFilterccount > 0 ? (
                                  <div className="storyGroupContainer">
                                    <div
                                      className="storyGroups"
                                      onClick={() => this.filterbyTag("all")}
                                    >
                                      All
                                    </div>
                                  </div>
                                ) : (
                                  <div className="storyGroupContainer">
                                    <div className="storyGroupsSelected">
                                      All
                                    </div>
                                  </div>
                                )}
                                {storyTemplates.map((tag, idx) => {
                                  return (
                                    <div
                                      className="storyGroupContainer"
                                      onClick={() => this.filterbyTag(tag)}
                                      key={idx}
                                    >
                                      <div
                                        className={
                                          Tagsfilters.indexOf(tag._id) > -1
                                            ? "storyGroupsSelected"
                                            : "storyGroups"
                                        }
                                      >
                                        {tag.name}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : null}
                          </div>

                          {/*
        1. listed tags.
        2.if select a tag, it will store in state and stories result return by select filter data
        3.selected tags changes button color dynamically
        4.selected multiple tags option added.
        5.if select all button : clear filter option and return onload stories resultt
      */}

                          <div
                            className={`stories-topics ${isMobile && "mt-2"}`}
                          >
                            <Row>
                              <Col sm="12">
                                <div className="templatePara1"> Tags </div>
                              </Col>
                            </Row>

                            {topics && topics.length > 0 ? (
                              <div
                                className={`${!isMobile &&
                                  "ml-3"} stories-topics-list`}
                              >
                                {selectedCategoriesFiltercount > 0 ? (
                                  <div className="storyGroupContainer">
                                    <div
                                      className="storyGroups"
                                      onClick={() => this.filterTopic("all")}
                                    >
                                      All
                                    </div>
                                  </div>
                                ) : (
                                  <div className="storyGroupContainer">
                                    <div className="storyGroupsSelected">
                                      All
                                    </div>
                                  </div>
                                )}

                                {topics.map((topic, idx) => {
                                  return (
                                    <div
                                      className="storyGroupContainer"
                                      onClick={() => this.filterTopic(topic)}
                                      key={idx}
                                    >
                                      <div
                                        className={
                                          filters.indexOf(topic.code) > -1
                                            ? "storyGroupsSelected"
                                            : "storyGroups"
                                        }
                                      >
                                        {topic.name}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : null}
                          </div>

                          {/* {
        1. While click on Close Filter Button, toggleCollapse function called, it will set auto toggle function for hide filter panel
        2. While click on Clear Filter Button, handleClearFilters function called, it will clear filter related state for get stories result with out filtration
      } */}
                          <div className="my-5">
                            <div className="col-md-6">
                              <span className="templatePara1">
                                Content Type
                              </span>
                              <Select
                                options={[
                                  { label: "Story", value: "story" },
                                  { label: "Comment", value: "comment" },
                                  { label: "All", value: "all" },
                                ]}
                                value={this.state.docType}
                                onChange={(x) =>
                                  this.setState({ docType: x.value }, () => {
                                    this.getStoryFilterFeeds();
                                  })
                                }
                                placeholder="Select type"
                                label="Content type"
                              />
                            </div>
                          </div>

                          <div
                            className="ipad-clear-filter"
                            style={{
                              marginTop: "30px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "18px",
                              lineHeight: "25px",
                            }}
                          >
                            {!isMobile ? (
                              <Button
                                color="secondary-filled"
                                onClick={this.toggleCollapse}
                              >
                                <span
                                  style={{
                                    fontSize: "18px",
                                    lineHeight: "25px",
                                  }}
                                >
                                  Close Filter
                                </span>
                              </Button>
                            ) : null}
                            <span
                              className="mobile-clear-filter"
                              style={{
                                marginLeft: "20px",
                                color: "#1679C4",
                                fontSize: "18px",
                                cursor: "pointer",
                                lineHeight: "25px",
                              }}
                              onClick={() => this.handleClearFilters(true)}
                            >
                              Clear Filters
                            </span>
                          </div>
                          {/* <hr style={{marginTop:'30px', marginBottom:'0px'}}/> */}
                        </div>
                      </Collapse>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {isMobile && isFilterCollapsed == false ? (
          <div>
            {/* <div className="templatePara1 ml-3"> {staticTitles.storyItemsU} ({this.state.totalStories}) </div> */}

            <ListGroup>{this.renderStories()}</ListGroup>
          </div>
        ) : null}
        {!isMobile ? (
          <div>
            {/* <div className="templatePara1 ml-3"> {staticTitles.storyItemsU} ({this.state.totalStories}) </div> */}

            <ListGroup>{this.renderStories()}</ListGroup>
          </div>
        ) : null}
        {/* 
1. BottomScrollListener work when page scroll function
2. its will call handleOnDocumentBottom function for get stories results based on skip value
*/}
        <BottomScrollListener
          offset={100}
          onBottom={this.handleOnDocumentBottom}
        />

        {isMobile && <FooterBar {...this.props} />}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    subtractStoryCount: (data) =>
      dispatch(actionCreators.subtractStoryCount(data)),
    // addStoryCount: (data) => dispatch(actionCreators.addStoryCount(data)),
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    resetNavBar: () => dispatch(actionCreators.navBarClear()),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(StoryAndComments, axios));
